import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import AppIndex from './components/app';

ReactDOM.render(
    <AppIndex />,
  document.getElementById('mainTag')
);

